import React from 'react';
import { Colors, Flex, Typography } from '@banhala/ui-kit';

type BestReviewChipProps = {
  visible: boolean;
};

export const BestReviewChip: React.FC<BestReviewChipProps> = ({ visible }) => {
  if (!visible) return null;

  return (
    <Flex
      padding={{ horizontal: 6, vertical: 2 }}
      backgroundColor={'bg_pink_primary'}
      borderRadius={'small'}
    >
      <Typography type={'body5'} rawColor={Colors.content_always_white}>
        BEST
      </Typography>
    </Flex>
  );
};
